import BaseLayoutView from 'app/src/views/base/BaseLayoutView';
import Format from 'app/src/data/Format';
import paymentViewTemplate from './templates/payment-view.hbs';

// configure
let View = BaseLayoutView.extend({
  template: paymentViewTemplate,
  regions: {
    content: '#payments_content',
  },
  ui: {
    paymentsTotal: '#payments_total',
  },
});

// define
export default class PaymentLayout extends View {
  /**
   * Event handler called before the view is rendered.
   */
  onBeforeRender() {
    window.Handlebars.registerHelper(
      'isPaymentProviderNotAvailable',
      () => !this.viewData.canRetrieveGateway
    );
  }

  /**
   * Sets the total displayed in the payments total field.
   *
   * @param total {*}     The total to be displayed in the total field.
   */
  updateTotal(total) {
    this.ui.paymentsTotal.val(Format.formatMoney(total, null, false));
  }
}
